import {
  ComponentMap,
  SbBlokData,
  storyblokImageLoader,
} from '@cinch-nx/data-storyblok'
import { StoryblokRendererV2 } from '@cinch-nx/storyblok-utils'
import cx from 'classnames'
import React from 'react'

import { homeStoryFallback } from '../../data/fallback/homepage-props-fallback'
import { HomepageVehiclesData } from '../../types/feature-home-page'
import { HeroCard } from './hero-card'
import { HeroCarousel } from './hero-carousel'
import { HeroTabs } from './hero-tabs'
import styles from './hero.module.css'

export interface HeroBlockProps {
  isHeroPromotional: boolean
  rightSideContent: SbBlokData[]
}

export interface HeroAdditionalProps {
  vehiclesData: HomepageVehiclesData
  storyFallback?: boolean
}

export interface HeroProps extends HeroBlockProps, HeroAdditionalProps {}

const heroComponents: ComponentMap = {
  HomeHeroCard: HeroCard,
  LoopingCarousel: HeroCarousel,
}

const HomeHeroV2: React.FC<HeroProps> = (props) => {
  const { isHeroPromotional, rightSideContent, storyFallback, vehiclesData } =
    props

  return (
    <section className={styles['container']} aria-describedby="hero-heading">
      <div
        className={cx(styles['background'], styles['backgroundGradient'], {
          [styles['backgroundGradientForPromo']]: isHeroPromotional,
        })}
      >
        <div className={styles['heroInner']}>
          <div className={styles.rightSideContainer}>
            <StoryblokRendererV2
              block={
                rightSideContent ??
                (homeStoryFallback.content.herov2?.[0]
                  ?.rightSideContent as SbBlokData[])
              }
              props={{
                ...(!storyFallback
                  ? { imageLoader: storyblokImageLoader }
                  : {}),
              }}
              components={heroComponents}
            />
          </div>

          <HeroTabs vehiclesData={vehiclesData} />
        </div>
      </div>
    </section>
  )
}

export default HomeHeroV2
